<cs-card>
  <cs-card-content class="support-content">
    <h3 class="card-title">{{ LL.profile.support() }}</h3>
    <p class="support-description" [innerHTML]="description ?? LL.profile.reportIssueInfo()"></p>
    <cs-button secondary small [label]="LL.profile.emailSupport()"
      (click)="handleEmailSupportClick()"></cs-button>
  </cs-card-content>
</cs-card>
